var locale = {
  'login.bell.title': '通知',
  'login.account.title': '账户',
  'login.account.user.id': 'uid',
  'login.account.user.info': '个人资料',
  logout: '退出登录',
  login: '登录'
};
export default locale;